import ReactDOM from 'react-dom';
import React from 'react';
import { App } from "./app";
export const Render = () => {
    ReactDOM.render(React.createElement(App, null), document.getElementById('react-app'));
};
Render();
